import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, isRef as _isRef, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, vModelRadio as _vModelRadio, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row justify-content-center" }
const _hoisted_2 = { class: "col-lg-12" }
const _hoisted_3 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_4 = { class: "card-body p-4" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-lg-6" }
const _hoisted_7 = { class: "form-group" }
const _hoisted_8 = { class: "position-relative" }
const _hoisted_9 = { class: "text-danger" }
const _hoisted_10 = { class: "col-lg-6" }
const _hoisted_11 = { class: "form-group" }
const _hoisted_12 = { class: "position-relative" }
const _hoisted_13 = { class: "text-danger" }
const _hoisted_14 = { class: "col-lg-6" }
const _hoisted_15 = { class: "form-group" }
const _hoisted_16 = { class: "position-relative" }
const _hoisted_17 = { class: "text-danger" }
const _hoisted_18 = { class: "col-lg-6" }
const _hoisted_19 = { class: "form-group" }
const _hoisted_20 = { class: "position-relative" }
const _hoisted_21 = { class: "text-danger" }
const _hoisted_22 = { class: "col-lg-6" }
const _hoisted_23 = { class: "form-group" }
const _hoisted_24 = { class: "d-flex flex-wrap gap-3 mb-4" }
const _hoisted_25 = { class: "d-flex align-items-center form-check style" }
const _hoisted_26 = { class: "flex-shrink-0" }
const _hoisted_27 = { class: "d-flex align-items-center form-check style" }
const _hoisted_28 = { class: "flex-shrink-0" }
const _hoisted_29 = { class: "text-danger" }

import { useField, useForm } from "vee-validate";
import { toTypedSchema } from "@vee-validate/zod";
import * as zod from "zod";
import { onMounted, ref } from "vue";
import router from "@/router";
import BaseLoading from "@/components/Common/BaseLoading.vue";
import { toast } from "vue-sonner";
import {
  VesselClassPayload,
  VesselClassResponse,
} from "@/types/interface/vessel-class";
import { useVesselClass } from "@/stores/master/vessel-class";


export default /*@__PURE__*/_defineComponent({
  __name: 'CreateVesselClass',
  setup(__props) {

const idVesselType = ref<string>("");
const isEdit = ref<boolean>(false);
const isLoading = ref<boolean>(false);
const vesselClassStore = useVesselClass();
const detailVesselClass = ref<VesselClassResponse>();

const validationSchema = toTypedSchema(
  zod.object({
    name: zod.string().nonempty({ message: "Name is required" }),
    code: zod.string().nonempty({ message: "Code is required" }),
    year: zod.string().nonempty({ message: "Year is required" }),
    head_office: zod.string().nonempty({ message: "Head Office is required" }),
    iacs_member: zod.boolean(),
  })
);

const { handleSubmit, errors } = useForm({
  validationSchema,
});

const { value: name } = useField<string>("name");
const { value: code } = useField<string>("code");
const { value: year } = useField<string>("year");
const { value: head_office } = useField<string>("head_office");
const { value: iacs_member } = useField<boolean>("iacs_member");

const onSubmit = handleSubmit(async (values) => {
  isLoading.value = true;
  const payloadVesselType: VesselClassPayload = {
    name: name.value,
    code: code.value,
    year: year.value,
    head_office: head_office.value,
    iacs_member: true,
  };

  const responseApi = ref<any>();

  if (isEdit.value == true) {
    responseApi.value = await vesselClassStore.dispatchUpdate(
      idVesselType.value,
      payloadVesselType
    );
  } else {
    responseApi.value = await vesselClassStore.dispatchCreate(
      payloadVesselType
    );
  }

  const { success, message } = responseApi.value;
  if (success == true) {
    setTimeout(() => {
      isLoading.value = false;
      toast.success(
        isEdit.value
          ? "Vessel Class Successfully Updated"
          : "Vessel Class Successfully Added"
      );
      router.push("/master/vessel-class");
    }, 1000);
  } else {
    isLoading.value = false;
    toast.error(message);
  }
});

const loadDetailVesselClass = async () => {
  const { success, message } = await vesselClassStore.dispatchDetail(
    idVesselType.value
  );
  if (success) {
    detailVesselClass.value = await vesselClassStore?.vesselClass?.data;
    name.value = detailVesselClass.value?.name;
    code.value = detailVesselClass.value?.code;
    year.value = detailVesselClass.value?.year;
    head_office.value = detailVesselClass.value?.head_office;
    iacs_member.value =
      detailVesselClass.value?.iacs_member == 1 ? true : false;
  }
};

onMounted(() => {
  if (router.currentRoute.value.params.id != undefined) {
    isEdit.value = true;
    idVesselType.value = router.currentRoute.value.params.id.toString();
    loadDetailVesselClass();
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[15] || (_cache[15] = _createElementVNode("div", { class: "d-flex justify-content-between align-items-center flex-wrap gap-3 mb-3 mb-lg-4" }, [
            _createElementVNode("h3", { class: "mb-0" }, "Form Create Vessel Class"),
            _createElementVNode("a", {
              class: "btn btn-danger fw-semibold text-white px-3",
              type: "button",
              href: "/master/vessel-type"
            }, [
              _createElementVNode("i", { class: "ri-arrow-drop-left-line text-gray-light" }),
              _createTextVNode(" Back To List Vessel Class ")
            ])
          ], -1)),
          (isLoading.value)
            ? (_openBlock(), _createBlock(BaseLoading, {
                key: 0,
                text: "Processing Data..."
              }))
            : _createCommentVNode("", true),
          (!isLoading.value)
            ? (_openBlock(), _createElementBlock("form", {
                key: 1,
                onSubmit: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_unref(onSubmit) && _unref(onSubmit)(...args))),
                class: "row g-3 needs-validation form"
              }, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _cache[7] || (_cache[7] = _createElementVNode("label", {
                        for: "name",
                        class: "form-label label text-secondary"
                      }, [
                        _createTextVNode("Name "),
                        _createElementVNode("span", { class: "text-danger" }, "*")
                      ], -1)),
                      _createElementVNode("div", _hoisted_8, [
                        _withDirectives(_createElementVNode("input", {
                          name: "name",
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(name) ? (name).value = $event : null)),
                          placeholder: "Name",
                          type: "text",
                          class: "form-control text-dark"
                        }, null, 512), [
                          [_vModelText, _unref(name)]
                        ])
                      ]),
                      _createElementVNode("span", _hoisted_9, _toDisplayString(_unref(errors).name), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _cache[8] || (_cache[8] = _createElementVNode("label", {
                        for: "code",
                        class: "form-label label text-secondary"
                      }, [
                        _createTextVNode("Code "),
                        _createElementVNode("span", { class: "text-danger" }, "*")
                      ], -1)),
                      _createElementVNode("div", _hoisted_12, [
                        _withDirectives(_createElementVNode("input", {
                          name: "code",
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(code) ? (code).value = $event : null)),
                          placeholder: "Vessel Type Code",
                          type: "text",
                          class: "form-control text-dark"
                        }, null, 512), [
                          [_vModelText, _unref(code)]
                        ])
                      ]),
                      _createElementVNode("span", _hoisted_13, _toDisplayString(_unref(errors).code), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                      _cache[9] || (_cache[9] = _createElementVNode("label", {
                        for: "year",
                        class: "form-label label text-secondary"
                      }, [
                        _createTextVNode("Year "),
                        _createElementVNode("span", { class: "text-danger" }, "*")
                      ], -1)),
                      _createElementVNode("div", _hoisted_16, [
                        _withDirectives(_createElementVNode("input", {
                          name: "year",
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(year) ? (year).value = $event : null)),
                          placeholder: "Vessel Year",
                          type: "text",
                          class: "form-control text-dark"
                        }, null, 512), [
                          [_vModelText, _unref(year)]
                        ])
                      ]),
                      _createElementVNode("span", _hoisted_17, _toDisplayString(_unref(errors).year), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("div", _hoisted_19, [
                      _cache[10] || (_cache[10] = _createElementVNode("label", {
                        for: "head_office",
                        class: "form-label label text-secondary"
                      }, [
                        _createTextVNode("Head Office "),
                        _createElementVNode("span", { class: "text-danger" }, "*")
                      ], -1)),
                      _createElementVNode("div", _hoisted_20, [
                        _withDirectives(_createElementVNode("input", {
                          name: "head_office",
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_isRef(head_office) ? (head_office).value = $event : null)),
                          placeholder: "Vessel Head Office",
                          type: "text",
                          class: "form-control text-dark"
                        }, null, 512), [
                          [_vModelText, _unref(head_office)]
                        ])
                      ]),
                      _createElementVNode("span", _hoisted_21, _toDisplayString(_unref(errors).head_office), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("div", _hoisted_23, [
                      _cache[13] || (_cache[13] = _createElementVNode("label", {
                        for: "iacs_member",
                        class: "form-label label text-secondary"
                      }, [
                        _createTextVNode(" IACS Member "),
                        _createElementVNode("span", { class: "text-danger" }, "*")
                      ], -1)),
                      _createElementVNode("div", _hoisted_24, [
                        _createElementVNode("div", _hoisted_25, [
                          _createElementVNode("div", _hoisted_26, [
                            _withDirectives(_createElementVNode("input", {
                              class: "form-check-input",
                              type: "radio",
                              style: {"width":"20px","height":"20px"},
                              name: "iacs_member",
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_isRef(iacs_member) ? (iacs_member).value = $event : null)),
                              value: true,
                              id: "iacs_member1"
                            }, null, 512), [
                              [_vModelRadio, _unref(iacs_member)]
                            ])
                          ]),
                          _cache[11] || (_cache[11] = _createElementVNode("div", { class: "flex-grow-1 ms-3" }, [
                            _createElementVNode("label", {
                              class: "form-check-label ps-0 fs-14 fw-medium text-secondary",
                              for: "iacs_member1"
                            }, " Yes ")
                          ], -1))
                        ]),
                        _createElementVNode("div", _hoisted_27, [
                          _createElementVNode("div", _hoisted_28, [
                            _withDirectives(_createElementVNode("input", {
                              class: "form-check-input",
                              type: "radio",
                              style: {"width":"20px","height":"20px"},
                              name: "iacs_member",
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_isRef(iacs_member) ? (iacs_member).value = $event : null)),
                              value: false,
                              id: "iacs_member2"
                            }, null, 512), [
                              [_vModelRadio, _unref(iacs_member)]
                            ])
                          ]),
                          _cache[12] || (_cache[12] = _createElementVNode("div", { class: "flex-grow-1 ms-3" }, [
                            _createElementVNode("label", {
                              class: "form-check-label ps-0 fs-14 fw-medium text-secondary",
                              for: "iacs_member2"
                            }, " No ")
                          ], -1))
                        ])
                      ]),
                      _createElementVNode("span", _hoisted_29, _toDisplayString(_unref(errors).iacs_member), 1)
                    ])
                  ]),
                  _cache[14] || (_cache[14] = _createElementVNode("div", { class: "col-12 mt-5" }, [
                    _createElementVNode("button", {
                      class: "btn btn-primary fw-semibold text-white py-2 px-3",
                      type: "submit"
                    }, " Save ")
                  ], -1))
                ])
              ], 32))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}
}

})